// src/components/AboutPage.js
import React, { useState } from 'react';
import './AboutPage.css';
import logo from '../assets/Editvibelogo1.svg';

const AboutPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const goToApp = () => window.location.href = 'https://app.editvibe.ai';
  const goToSite = () => window.location.href = 'https://editvibe.ai';

  return (
    <div className="evmp-mainpage">
      {/* ——— Header (same as main) ——— */}
      <header className="evmp-header">
        <div className="evmp-header-inner">
          <a href="https://editvibe.ai">
            <img src={logo} alt="EditVibe Logo" className="evmp-logo" />
          </a>

          <button
            className="evmp-mobile-toggle"
            onClick={() => setMobileMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            ☰
          </button>

          <nav className={`evmp-nav ${mobileMenuOpen ? 'open' : ''}`}>
            <a href="https://editvibe.ai">Features</a>
            <a href="https://editvibe.ai">Solutions</a>
            <a href="https://editvibe.ai">Articles</a>
            <a href="https://editvibe.ai">FAQ</a>
            <button
              className="evmp-btn evmp-btn-primary evmp-btn-moema"
              onClick={goToApp}
            >
              Get Started
            </button>
          </nav>
        </div>
      </header>

      {/* ——— Centered About Section ——— */}
      <section className="evmp-about-centered">
        <h1 className="evmp-about-title">About EditVibe</h1>
        <p className="evmp-about-text">
          At EditVibe, we believe the true power of video editing lies in creativity, understanding not just what makes a cut
          work, but why that idea resonated with its creator in the first place. To unlock this potential, we’ve deconstructed
          the entire editing workflow, from the spark of an idea to the polished final cut and amassed a rich dataset of
          decisions that professional editors make every day. This data captures the logic and creative rationale behind each
          transition, each pacing choice, each moment of emphasis. We’re leveraging these insights to train AI models that 
          don’t merely speed up repetitive tasks, but genuinely contribute to the creative process with deep editorial understanding.
          <br /><br />
          We envision a future where complex editing suites give way to intelligent AI engines that orchestrate every step of
          production. With platforms like EditVibe‑95, creators will upload their raw footage, describe their vision, and receive
          a fully realized video, no timelines, no plugins, no manual tinkering. This shift will free storytellers to spend less
          time behind a computer and more time bringing their ideas to life. At EditVibe, we’re already making that future a reality.
        </p>
      </section>

      {/* ——— Footer (same as main) ——— */}
      <footer className="evmp-footer">
  <div className="evmp-footer-col">
    <h4>Company</h4>
    <a
      href="https://editvibe.ai"
      target="_self"
      rel="noopener noreferrer"
    >
      About
    </a>
  </div>
  <div className="evmp-footer-col">
    <h4>Product</h4>
    <a
      href="https://editvibe.ai"
      target="_self"
      rel="noopener noreferrer"
    >
      Features
    </a>
  </div>
  <div className="evmp-footer-col">
    <h4>Resources</h4>
    <a
      href="https://editvibe.ai"
      target="_self"
      rel="noopener noreferrer"
    >
      Blog
    </a>
  </div>
  <div className="evmp-footer-col">
    <h4>Support</h4>
    <a
      href="https://editvibe.ai"
      target="_self"
      rel="noopener noreferrer"
    >
      Contact Us
    </a>
  </div>
</footer>
    </div>
  );
};

export default AboutPage;
